import * as types from './types'
import http from '../../utils/http'
// import Vue from 'vue'

// const vue = new Vue()
const state = {
  /*
   * 数据中心平台首页
   */
  pageAct: 1, // 地图数据
  merchantBasicInformation: {
    valueOfGoods: '0'
  },
  merchantList: [] // 商户列表
}

const actions = {
  [types.CHANGEPAGE] (context, params) {
    context.commit(types.CHANGEPAGE, params)
  },
  /**
   * 数据中心平台首页（商户端）
   */
  // 获取地图数据
  [types.GETMAPLIST] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/homePage/getWarehouseDistributionMap', params).then(data => {
        resolve(data)
      })
    })
  },
  // 获取每日支付金额统计
  [types.GETPAYAMOUNT] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/homePage/getDailyPaymentAmountStatistics', params).then(data => {
        resolve(data)
      })
    })
  },
  // 仓库收入统计
  [types.GETWAREHOUSEINCOME] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/homePage/getWarehouseRevenueStatistics', params).then(data => {
        resolve(data)
      })
    })
  },
  // 近30天商品销量排行TOP10
  [types.GETSALESRANK] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/homePage/getCommoditySalesRanking', params).then(data => {
        resolve(data)
      })
    })
  },
  // 上月配送平台出货量统计
  [types.GETPLATFORMSHIPMENT] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/homePage/getPlatformShipmentStatistics', params).then(data => {
        resolve(data)
      })
    })
  },
  // 供应商活跃度
  [types.GETSUPPLYACTIVE] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/homePage/getSupplierActivity', params).then(data => {
        resolve(data)
      })
    })
  },
  // 单仓日平均完成任务数TOP5
  [types.GETWAREHOUSETASK] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/homePage/getWarehouseTaskAverage', params).then(data => {
        resolve(data)
      })
    })
  },
  /**
   * 仓库收入统计（商户端）
   */
  [types.GETWAREHOUSEREVENUESTATISTICAL] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/warehouseStatistical/getWarehouseRevenueStatistical', params).then(data => {
        resolve(data)
      })
    })
  },
  /**
   * 仓库出入库统计（商户端）
   */
  // 获取仓库下拉框
  [types.GETALLWAREHOUSE] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/warehouse/getAllWareHouse', params).then(data => {
        resolve(data.obj)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 获取仓库出入库数量
  [types.GETALLTASK] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/taskCount/getAllTask', params).then(data => {
        resolve(data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 获取出库商品重量/体积
  [types.GETOUTTASKWEIGHTANDVOLUME] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/taskCount/getOutTaskWeightAndVolume', params).then(data => {
        resolve(data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 获取仓库入库数量占比
  [types.GETENTERTASK] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/taskCount/getEnterTask', params).then(data => {
        resolve(data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 获取仓库出库数量占比
  [types.GETSELLTASK] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/taskCount/getSellTask', params).then(data => {
        resolve(data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  /**
   * 供应商数据统计（商户端）
   */
  // 出货量统计、账单金额统计、费用类型占比、支付率和支付及时率
  [types.GETSUPPLIERDATASTATISTICAL] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/supplierStatistical/getSupplierDataStatistical', params).then(data => {
        resolve(data)
      })
    })
  },
  // 供应商账单总金额排行TOP20
  [types.GETSUPPLIERDATATOP20] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/supplierStatistical/getSupplierDataTop20', params).then(data => {
        resolve(data)
      })
    })
  },
  // 查看明细列表
  [types.GETSUPPLIERDATATOPDETAIL] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/supplierStatistical/getSupplierDataTopDetail', params).then(data => {
        resolve(data)
      })
    })
  },
  // 导出明细
  [types.EXPORTSUPPLIERDATATOPDETAIL] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/supplierStatistical/exportSupplierDataTopDetail', params).then(data => {
        resolve(data)
      })
    })
  },
  // 供应商无数据时返回x轴坐标
  [types.GETSUPPLYDATAAXIS] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/supplierStatistical/getSupplierDataStatisticalUnitAxis', params).then(data => {
        resolve(data)
      })
    })
  },
  /**
   * 商品销售统计（商户端）
   */
  // 商品销量排行TOP20
  [types.GETGOODSDATATOP20] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/goodStatistical/getGoodsDataTop20', params).then(data => {
        resolve(data)
      })
    })
  },
  // 销售量统计、多余退货率、售后退货率
  [types.GETGOODSREVENUESTATISTICAL] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/goodStatistical/getGoodsRevenueStatistical', params).then(data => {
        resolve(data)
      })
    })
  },
  // 查看明细列表
  [types.GETGOODSDATATOPDETAIL] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/goodStatistical/getGoodsDataTopDetail', params).then(data => {
        resolve(data)
      })
    })
  },
  // 导出明细
  [types.EXPORTGOODSDATATOPDETAIL] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/goodStatistical/exportGoodsDataTopDetail', params).then(data => {
        resolve(data)
      })
    })
  },
  // 获取商品下拉框
  [types.GETALLGOOD] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/goods/getAllGood', params).then(data => {
        resolve(data)
      })
    })
  },
  // 获取供应商下拉框
  [types.SUPPLIER] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/supplierStatistical/getSupplierSelectList', params).then(data => {
        resolve(data)
      })
    })
  },
  // 获取商品供应商下拉框
  [types.GOODSUPPLIER] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/goodStatistical/getSupplierSelectList', params).then(data => {
        resolve(data)
      })
    })
  },
  /**
   * 数据中心平台首页（saas端）
   */
  // 获取三个统计数量
  [types.GETGOODSSTOCKS] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/saas/homePage/getGoodsStocks', params).then(data => {
        resolve(data)
      })
    })
  },
  // 获取地图数据
  [types.GETWAREHOUSEDISTRIBUTIONMAP] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/saas/homePage/getWarehouseDistributionMap', params).then(data => {
        resolve(data)
      })
    })
  },
  // 商户总库存排行
  [types.GETMERCHANTTOTALINVENTORYRANKING] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/saas/homePage/getMerchantTotalInventoryRanking', params).then(data => {
        resolve(data)
      })
    })
  },
  // 近30天商品销量排行TOP10
  [types.GETCOMMODITYSALESRANKING] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/saas/homePage/getCommoditySalesRanking', params).then(data => {
        resolve(data)
      })
    })
  },
  // 全平台已支付账单总金额
  [types.GETTHETOTALAMOUNTOFBILLSPAIDACROSSTHEPLATFORM] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/saas/homePage/getTheTotalAmountOfBillsPaidAcrossThePlatform', params).then(data => {
        resolve(data)
      })
    })
  },
  // 品类销量占比(近30天)
  [types.GETCATEGORYSALESRATIO] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/saas/homePage/getCategorySalesRatio', params).then(data => {
        resolve(data)
      })
    })
  },
  /**
   * 商品分析（saas端）
   */
  // 获取商品销量排行、品类销量占比、品类交易额占比
  [types.GETGOODSREVENAUESTATISTICAL] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/saas/goodStatistical/getGoodsRevenueStatistical', params).then(data => {
        resolve(data)
      })
    })
  },
  // 品类销量热力图
  [types.GETCATEGORYSALESHEATMAP] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/saas/goodStatistical/getCategorySalesHeatmap', params).then(data => {
        resolve(data)
      })
    })
  },
  // 品类销量热力图 - 下拉框
  [types.GETGOODSCATEGORYSELECT] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/saas/goodStatistical/getGoodsCategorySelect', params).then(data => {
        resolve(data)
      })
    })
  },
  // 商户统计 基本数据
  [types.GETBASICINFORMATION] (context, params) {
    http.fetch('/api/saas/merchantStatistics/getBasicInformation', params).then(data => {
      context.commit(types.GETBASICINFORMATION, data)
    })
  },
  // 商户统计 每日出货量
  [types.GETDAILYSHIPMENTS] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/saas/merchantStatistics/getDailyShipments', params).then(data => {
        resolve(data)
      })
    })
  },
  // 商户统计 每月已支付账单金额
  [types.GETAMOUNTOFBILLSPAIDPERMONTH] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/saas/merchantStatistics/getAmountOfBillsPaidPerMonth', params).then(data => {
        resolve(data)
      })
    })
  },
  // 供应商统计
  [types.DATASUPPLIER] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/data/dataSupplier', params).then(data => {
        resolve(data)
      })
    })
  },
  // 商户列表 GETMERCHANTSELECT
  [types.GETMERCHANTSELECT] (context, params) {
    http.fetch('/api/saas/merchantStatistics/getMerchantSelect', params).then(data => {
      context.commit(types.GETMERCHANTSELECT, data)
    })
  }
}

const mutations = {
  [types.CHANGEPAGE] (state, data) {
    state.pageAct = data
  },
  [types.GETBASICINFORMATION] (state, data) {
    state.merchantBasicInformation = data.obj
  },
  [types.GETMERCHANTSELECT] (state, data) {
    state.merchantList = data.obj
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/dataCenter/index.js